import { render, staticRenderFns } from "./DepartmentTable.vue?vue&type=template&id=6c1777a6&scoped=true"
import script from "./DepartmentTable.vue?vue&type=script&lang=js"
export * from "./DepartmentTable.vue?vue&type=script&lang=js"
import style0 from "./DepartmentTable.vue?vue&type=style&index=0&id=6c1777a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1777a6",
  null
  
)

export default component.exports